export default {
  stepNotFound: 'Step not found',
  noDescription: 'No description',
  expectedStartDate: 'Expected Start Date',
  batchName: 'Batch Name',
  nextStep: 'Next Step',
  noUpcomingSteps: 'No upcoming steps'
};
